var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.895,
    height: 17.141,
    viewBox: "0 0 17.895 17.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-edit",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M29.455,7.583h3.056a.414.414,0,0,0,.41-.41h0a.5.5,0,0,0-.112-.3l-3.8-3.763A.5.5,0,0,0,28.71,3h0a.414.414,0,0,0-.41.41V6.428A1.161,1.161,0,0,0,29.455,7.583Z",
    transform: "translate(-16.5 0)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M40.061,24.853l-.335-.335a.584.584,0,0,0-.82,0l-4.434,4.434c-.037.037,0,.075,0,.112V30c0,.075,0,.149.075.149h.969c.037,0,.075-.037.112-.037l4.434-4.4A.566.566,0,0,0,40.061,24.853Z",
    transform: "translate(-20.362 -13.395)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M16.122,18.427H13.477A1.081,1.081,0,0,1,12.4,17.346V15.334a.9.9,0,0,1,.335-.783l3.54-3.54a.6.6,0,0,0,.186-.41V9.856A.573.573,0,0,0,15.9,9.3H11.8a1.709,1.709,0,0,1-1.714-1.714V3.559A.581.581,0,0,0,9.49,3H3.714A1.734,1.734,0,0,0,2,4.714V18.427a1.734,1.734,0,0,0,1.714,1.714H14.669a1.759,1.759,0,0,0,1.714-1.379A.3.3,0,0,0,16.122,18.427ZM4.31,8.142a.573.573,0,0,1,.559-.559h2.31a.549.549,0,0,1,.559.559V8.7a.573.573,0,0,1-.559.559H4.869A.549.549,0,0,1,4.31,8.7Zm5.776,7.415a.573.573,0,0,1-.559.559H4.869a.549.549,0,0,1-.559-.559V15a.573.573,0,0,1,.559-.559H9.49a.549.549,0,0,1,.559.559v.559Zm1.155-3.428a.573.573,0,0,1-.559.559H4.869a.549.549,0,0,1-.559-.559V11.57a.573.573,0,0,1,.559-.559h5.776a.549.549,0,0,1,.559.559v.559Z",
    transform: "translate(0 0)",
    fill: "#f26122"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.d1f4d008.svg";
export { ForwardRef as ReactComponent };